export const NAV_HEIGHT = '8rem';
export const NAV_SMALL_HEIGHT = '5rem';

export const FOOTER_WIDTH = '125rem';
export const EVENT_SECTION_WIDTH = '154rem';
export const BLOG_ITEM_WIDTH = '50rem';
export const SPEAKER_PAGE_WIDTH = '113rem';
export const EVENT_HOME_WIDTH = '140rem';
export const CONTACT_FORM_WIDTH = '84rem';
export const HEADER_HEIGHT = '6rem';

export const EMAIL = {
  SUPPORT: 'support@we-conect.com',
  LUFTHANSA: 'lufthansa.mobility@dhl.de',
  OPERATIONS: 'eike.nenninger@we-conect.com',
};
export const THEME = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const;

export const THEME_TYPE = ['LIGHT', 'DARK'] as const;

export const MODE = {
  OVERVIEW: 'overview',
  PORTFOLIO: 'portfolio',
  EVENT: 'event',
  WEBINAR: 'webinar',
} as const;

export const MODE_TYPE = [
  MODE.OVERVIEW,
  MODE.PORTFOLIO,
  MODE.EVENT,
  MODE.WEBINAR,
] as const;

export const LANGUAGE = {
  ENGLISH: 'en',
  GERMAN: 'de',
} as const;

export const LANGUAGE_TYPE = [LANGUAGE.ENGLISH, LANGUAGE.GERMAN] as const;

export const LANGUAGE_INTL = {
  en: 'en-GB',
  de: 'de-DE',
} as const;

export const LANGUAGE_INTL_TYPE = ['en-GB', 'de-DE'] as const;

export const SPONSOR_EMAIL = 'partnering@we-conect.com';
export const SPEAKER_EMAIL = 'speaking@we-conect.com';
export const ATTENDEE_EMAIL = 'bookings@we-conect.com';
export const MEDIA_PARTNERSHIP_EMAIL = 'marketing@we-conect.com';
export const GENERAL_ENQUIRIES = 'info@we-conect.com';

export const LOCAL_STORAGE_TYPE = {
  LANGUAGE: 'language',
};

export const LANGUAGE_SWITCHER_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const LANGUAGE_SWITCHER_MODE_TYPE = [
  LANGUAGE_SWITCHER_MODE.LIGHT,
  LANGUAGE_SWITCHER_MODE.DARK,
] as const;

export const SCROLL_DOWN_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const SCROLL_DOWN_MODE_TYPE = [
  SCROLL_DOWN_MODE.LIGHT,
  SCROLL_DOWN_MODE.DARK,
] as const;

export const PARTNER = {
  COMPETENCE: 'competence',
  BUSINESS: 'business',
  EVENT_LEAD: 'event-lead',
  PRIMARY: 'primary',
  MEDIA: 'media',
} as const;

export const PARTNER_TYPE = [
  PARTNER.COMPETENCE,
  PARTNER.BUSINESS,
  PARTNER.EVENT_LEAD,
  PARTNER.PRIMARY,
  PARTNER.MEDIA,
] as const;

export const eventNetworkingItems = [
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-1',
  },
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-3',
  },

  {
    icon: 'speaker',
    title: 'event-networking-modal-text-5',
  },
  {
    icon: 'attendees',
    title: 'event-networking-modal-text-7',
  },
  {
    icon: 'meeting',
    title: 'event-networking-modal-text-9',
  },

  {
    icon: 'attendee',
    title: 'event-networking-modal-text-11',
  },
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-13',
  },
  {
    icon: 'speaker',
    title: 'event-networking-modal-text-15',
  },
  {
    icon: 'attendees',
    title: 'event-networking-modal-text-17',
  },
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-19',
  },
];

export const multiTouchPointItems = [
  {
    id: 'casestudy',
    title: 'event-networking-modal-text-1',
    subtitle: 'event-networking-modal-text-2',
    imageUrl: 'https://media.we-conect.com/images/pdf/agenda/casestudy.jpg',
  },
  {
    id: 'worldcafe',
    title: 'event-networking-modal-text-3',
    subtitle: 'event-networking-modal-text-4',
    imageUrl: 'https://media.we-conect.com/images/pdf/agenda/worldcafe.jpg',
  },
  {
    id: 'icebreaker',
    title: 'event-networking-modal-text-5',
    subtitle: 'event-networking-modal-text-6',
    imageUrl: 'https://media.we-conect.com/images/pdf/agenda/icebreaker.jpg',
  },
  {
    id: 'paneldiscussion',
    title: 'event-networking-modal-text-7',
    subtitle: 'event-networking-modal-text-8',
    imageUrl:
      'https://media.we-conect.com/images/pdf/agenda/panel_discussion.jpg',
  },
  {
    id: 'sayhello',
    title: 'event-networking-modal-text-9',
    subtitle: 'event-networking-modal-text-10',
    imageUrl:
      'https://media.we-conect.com/images/pdf/agenda/say_hello_session.jpg',
  },
  {
    id: '100minutes',
    title: 'event-networking-modal-text-11',
    subtitle: 'event-networking-modal-text-12',
    imageUrl: 'https://media.we-conect.com/images/pdf/agenda/100minutes.jpg',
  },
  {
    id: 'networkingdinner',
    title: 'event-networking-modal-text-13',
    subtitle: 'event-networking-modal-text-14',
    imageUrl:
      'https://media.we-conect.com/images/pdf/agenda/networking_dinner.jpg',
  },
  {
    id: 'challengeyourpeers',
    title: 'event-networking-modal-text-15',
    subtitle: 'event-networking-modal-text-16',
    imageUrl:
      'https://media.we-conect.com/images/pdf/agenda/challengeyourpeers.jpg',
  },
  {
    id: 'solutionstudy',
    title: 'event-networking-modal-text-17',
    subtitle: 'event-networking-modal-text-18',
    imageUrl: 'https://media.we-conect.com/images/pdf/agenda/solutionstudy.jpg',
  },
  {
    id: 'digitalplatform',
    title: 'event-networking-modal-text-19',
    subtitle: 'event-networking-modal-text-20',
    imageUrl:
      'https://media.we-conect.com/images/pdf/agenda/digitalplatform.jpg',
  },
];

export const multiTouchPointPDFItems = [
  {
    id: 'casestudy',
    title: 'multitouchpoint-pdf-item-1-title',
    subtitle: 'multitouchpoint-pdf-item-1-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/6_1.png',
  },
  {
    id: 'world-cafes-roundables',
    title: 'multitouchpoint-pdf-item-2-title',
    subtitle: 'multitouchpoint-pdf-item-2-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/6_2.png',
  },
  {
    id: 'pre-event-networking-icebreaker',
    title: 'multitouchpoint-pdf-item-3-title',
    subtitle: 'multitouchpoint-pdf-item-3-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/6_3.png',
  },
  {
    id: 'panel-discussion',
    title: 'multitouchpoint-pdf-item-4-title',
    subtitle: 'multitouchpoint-pdf-item-4-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/6_4.png',
  },
  {
    id: 'say-hello',
    title: 'multitouchpoint-pdf-item-5-title',
    subtitle: 'multitouchpoint-pdf-item-5-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/6_5.png',
  },
  {
    id: 'individual-one-on-one',
    title: 'multitouchpoint-pdf-item-6-title',
    subtitle: 'multitouchpoint-pdf-item-6-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/7_1.png',
  },
  {
    id: 'networking-dinner',
    title: 'multitouchpoint-pdf-item-7-title',
    subtitle: 'multitouchpoint-pdf-item-7-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/7_2.png',
  },
  {
    id: 'challenge-your-peers',
    title: 'multitouchpoint-pdf-item-8-title',
    subtitle: 'multitouchpoint-pdf-item-8-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/7_3.png',
  },
  {
    id: 'solutions-studies',
    title: 'multitouchpoint-pdf-item-9-title',
    subtitle: 'multitouchpoint-pdf-item-9-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/7_4.png',
  },
  {
    id: 'live-streaming-event-platform',
    title: 'multitouchpoint-pdf-item-10-title',
    subtitle: 'multitouchpoint-pdf-item-10-text',
    imageUrl:
      'https://media.we-conect.com/images/pdf/partnerprospectus/7_5.png',
  },
];

export const mappableCompanyRouteKeys = [
  'career-url',
  'terms-and-conditions-url',
  'our-awards-url',
  'about-us-url',
  'social-responsibility-url',
  'contact-url',
  'newsletter-unsubscribe-url',
  'imprint-url',
  'our-team-url',
  'our-product-portfolio-url',
  'multitouchpoint-networking-url',
  'declaration-of-consent-url',
];
